import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import AccessControl from "app/components/AccessControl";

export const getAccessControlButton = (
  accessLevel,
  clickEvent,
  icon,
  tooltipTitle = "",
) => {
  return {
    getValue: qualification => (
      <AccessControl accessLevel={accessLevel}>
        <Tooltip title={tooltipTitle}>
          <IconButton onClick={() => clickEvent(qualification)}>
            {icon}
          </IconButton>
        </Tooltip>
      </AccessControl>
    ),
  };
};
